if (!customElements.get('random-quote')) {
  customElements.define('random-quote', class extends HTMLElement {
    async connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      let quotes = JSON.parse(this.querySelector('[data-quote-fallback]').textContent);
      const source = this.dataset.source;
      if (source) {
        try {
          const response = await fetch(source, { signal: AbortSignal.timeout(4000) });
          if (!response.ok) throw new Error('Quotes unavailable');
          const parsed = (await response.text()).split(/\r?\n/).flatMap((line) => {
            const match = line.match(/^\s*(\d+)\s+(.+?)\s*$/);
            return match ? [{ number: match[1], text: match[2].trim() }] : [];
          });
          if (parsed.length) quotes = parsed;
        } catch {}
      }
      let previous;
      const key = 'onlybobs:last-announcement-quote';
      try { previous = sessionStorage.getItem(key); } catch {}
      const alternatives = quotes.filter((quote) => quote.number !== previous);
      const pool = alternatives.length ? alternatives : quotes;
      if (!pool.length) return;
      const selected = pool[Math.floor(Math.random() * pool.length)];
      this.querySelector('[data-quote-text]').textContent = `Bob Quote No. ${selected.number} — ${selected.text}`;
      try { sessionStorage.setItem(key, selected.number); } catch {}
    }
  });
}
